import { Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utils/routes';

const SECTION_TABS = [
  { label: 'Registry', path: ROUTES.GUARDRAILS },
  { label: 'Bindings', path: ROUTES.GUARDRAIL_BINDINGS },
  { label: 'Executions', path: ROUTES.GUARDRAIL_EXECUTIONS },
] as const;

/**
 * Top-level navigation between the three Guardrails admin pages.
 */
export const GuardrailsSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activePath =
    SECTION_TABS.find((tab) => location.pathname === tab.path)?.path ?? ROUTES.GUARDRAILS;

  return (
    <Tabs
      value={activePath}
      onChange={(_, path: string) => navigate(path)}
      sx={{ mb: 4 }}
      aria-label="Guardrails sections"
    >
      {SECTION_TABS.map((tab) => (
        <Tab key={tab.path} label={tab.label} value={tab.path} />
      ))}
    </Tabs>
  );
};
